import "antd/dist/antd.min.css";
import React, { useReducer } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useReducerAsync } from "use-reducer-async";
import "../src/App.css";

import Authenticated from "./Middleware/Authenticated";
import ConfirmModal from "./components/ConfirmModal";
import Explorer from "./components/Explorer";
import Home from "./components/Home";
import NewFlowPage from "./components/NewFlowPage";
import PageTitle from "./components/PageTitle";
import Simulation from "./components/Simulation";
import Notification from "./components/notification";
import ConfirmApiContext from "./contexts/confirmApi";
import FetchContext from "./contexts/fetch";
import FlowContext from "./contexts/flowContext";
import NotificationContext from "./contexts/notification";
import SidebarContext from "./contexts/sidebar";
import SimulationContext from "./contexts/simulation";
import UserContext from "./contexts/user";
import {
  reducer as confirmApiReducer,
  initialState as confirmApiState,
} from "./reducers/confirmApi";
import {
  asyncActions as configAsyncActions,
  initialState as fetchContext,
  reducer as fetchReducer,
} from "./reducers/fetch";
import {
  reducer as flowReducer,
  initialState as flowState,
} from "./reducers/flow";
import {
  reducer as notificationReducer,
  initialState as notificationState,
} from "./reducers/notification";
import {
  reducer as sidebarReducer,
  initialState as sidebarState,
} from "./reducers/sidebar";
import {
  reducer as simulationReducer,
  initialState as simulationState,
} from "./reducers/simulation";
import {
  reducer as userReducer,
  initialState as userState,
} from "./reducers/user";

const App = () => {
  const userContextValue = useReducer(userReducer, userState);
  const sidebarContextValue = useReducer(sidebarReducer, sidebarState);
  const flowContextValue = useReducer(flowReducer, flowState);
  const configContextValue = useReducerAsync(
    fetchReducer,
    fetchContext,
    configAsyncActions
  );
  const notificationContextValue = useReducer(
    notificationReducer,
    notificationState
  );
  const confirmApiContextValue = useReducer(confirmApiReducer, confirmApiState);
  const simulationContextValue = useReducer(simulationReducer, simulationState);

  return (
    <div>
      <UserContext.Provider value={userContextValue}>
        <FetchContext.Provider value={configContextValue}>
          <NotificationContext.Provider value={notificationContextValue}>
            <ConfirmApiContext.Provider value={confirmApiContextValue}>
              <SidebarContext.Provider value={sidebarContextValue}>
                <FlowContext.Provider value={flowContextValue}>
                  <SimulationContext.Provider value={simulationContextValue}>
                    <Authenticated>
                      <PageTitle />

                      <ConfirmModal />

                      <Notification />

                      <Simulation />

                      <BrowserRouter>
                        <Routes>
                          <Route path="/" element={<Explorer />} />
                          <Route
                            exact
                            path="/new-flow"
                            element={<NewFlowPage />}
                          />
                          <Route path="/:app" element={<Home />}>
                            <Route path="/:app/:brand" element={<Home />}>
                              <Route
                                path="/:app/:brand/:flowName/:version"
                                element={<Home />}
                              />
                            </Route>
                          </Route>
                        </Routes>
                      </BrowserRouter>
                    </Authenticated>
                  </SimulationContext.Provider>
                </FlowContext.Provider>
              </SidebarContext.Provider>
            </ConfirmApiContext.Provider>
          </NotificationContext.Provider>
        </FetchContext.Provider>
      </UserContext.Provider>
    </div>
  );
};

export default App;
